export const updateLogo="更新我的Logo";
export const noPermission="无权限";
export const siteMap="站点地图";
export const searchList="搜索结果";
export const contactUs="联系我们";
export const guideline="My-invoice 指引";
export const transaction="交易数据管理";
export const view="查看";
export const operationLog="操作日志";
export const invoiceIssuance="修改&开具";
export const selectBuyer="选择买方";
export const selectSupplier="选择卖方";
export const addPayment="添加付款";
export const addAddition="添加附加费";
export const modifyAddition="修改附加费";
export const addTax="添加税款明细";
export const modifyTax="修改税款明细";
export const addItem="添加商品";
export const selectGoods="选择商品";
export const modifyItem="修改商品";
export const invoiceUpload="上传";
export const invoiceUploadRecords="上传记录";
export const add="添加";
export const viewInvalidReasons="查看无效原因";
export const purchase="我的进项发票";
export const rejectInvoice="拒收";
export const invoice="发票管理";
export const cancelInvoice="取消";
export const shareInvoice="分享发票PDF";
export const myProfile="个人中心";
export const taxpayerInfo="纳税人信息维护";
export const batchImportPage="批量导入";
export const taxpayerDetail="合同详情";
export const contractView="合同信息";
export const userBinding="用户绑定";
export const roleManagement="角色管理";
export const viewOperationLog="查看操作日志";
export const debitNoteList="Debit Note管理";
export const selectInvoiceList="选择发票";
export const debitNoteForm="开具 Debit Note";
export const credit="Credit Note管理";
export const creditNoteForm="开具 Credit Note";
export const refund="Refund Note管理";
export const refundNoteForm="开具 Refund Note";
export const invoicingConsolidated="发票合并管理";
export const transactionConsolidatedForm="发票预览";
export const viewItem="查看项目";
export const viewItemTax="查看项目税额";
export const viewTax="查看税额详情";
export const transactionSeparatedManagement="查看交易数据";
export const report="操作日志报表";
export const operationDetails="查看详细信息";
export const downloadTask="下载任务";
export const viewDetails='查看详情';
export const goodsService="产品&服务";
export const modify="修改";
export const frequentContacts="供应商&买方";
export const consolidateTaskList="交易合并任务";
export const consolidateTaskForm="执行合并任务";
export const failureReason="查看失败原因";
